export interface IClickChainApplicable {
  clickChainIdentifier: string;
}

export function instanceOfIClickChainApplicable(instance: any): instance is IClickChainApplicable {
  return instance
    && (instance.clickChainIdentifier !== undefined);
}
